export default "__VITE_ASSET__5MLEcQlK__"